export function formatStringWithSpaces(string, interval) {
    // defaults to a space after 4 characters:
    interval = interval || 4;
    /* removes all characters in the value that aren't a number,
       or in the range from A to Z (uppercase): */
    let v = string.replace(/[^\dA-Z]/g, ''),
    /* creating the regular expression, to allow for the 'after' variable
       to be used/changed: */
    reg = new RegExp(".{" + interval + "}","g");
    string = v.replace(reg, function (a, b, c) {
        return a + ' ';
    }); 
    return string;
}
